"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimalCacheProcessFnTxnList = exports.optimalCacheCompareFnBubble = exports.optimalCacheCompareFnPostedOnAndAmount = exports.optimalCacheCompareFnPostedOn = exports.optimalCacheProcessFnRecentAcctTxns = exports.optimalCacheProcessFnTxnGrouped = exports.optimalCacheCompareFn = exports.optimalCacheProcessFn = void 0;
const core_1 = require("companion-app-components/utils/core");
const utils_1 = require("data/transactions/utils");
const log = (0, core_1.getLogger)('data/transactionList/optimalCacheFunctions');
// Attempt to process newTxn into the cache
// returns the new cache, or NULL if a recalc is needed (can't resolve the cache)
const optimalCacheProcessFn = (cachedValues, newTxn, filterFn) => {
    let txIndex = -1;
    let sectionKey = null;
    cachedValues.forEach((sec, key) => {
        const index = sec.findIndex((txn) => txn.id === newTxn.id);
        if (index !== -1) {
            sectionKey = key;
            txIndex = index;
        }
    });
    // console.log("PROCESSING looking for ", newTxn);
    if (txIndex !== -1 && sectionKey) {
        // check for deleted or whether this txn was filtered out of the list
        if (newTxn.isDeleted || (filterFn && filterFn([newTxn]).length === 0)) {
            return cachedValues.set(sectionKey, cachedValues.get(sectionKey).remove(txIndex));
        }
        const newTxnMerge = newTxn.set('balance', cachedValues.getIn([sectionKey, txIndex]).balance);
        return cachedValues.setIn([sectionKey, txIndex], newTxnMerge);
    }
    return newTxn.isDeleted ? cachedValues : null; // if new txn was deleted, and not found, that is ok
};
exports.optimalCacheProcessFn = optimalCacheProcessFn;
// Returns TRUE if the changes do NOT cause a recalc of the selector and allow
// for cache replacement
const optimalCacheCompareFn = (oldTxn, newTxn, sortBy, filterFn) => {
    // determine which fields changed
    const diffs = (0, utils_1.getTxnDifferences)(oldTxn.toJS(), newTxn.toJS());
    log.debug('TXNlist DIFFS ARE ', diffs, sortBy);
    if (filterFn && filterFn([newTxn]).length === 0) {
        return true; // we will delete this transaction in the process function
    }
    const ret = (!diffs.includes('postedOn') &&
        !diffs.includes('amount') && !diffs.includes('isDeleted') && // always resort on date or amount change
        !(diffs.includes('isReviewed') && (0, utils_1.isC2RTransaction)(oldTxn)) &&
        !(sortBy === 'status' && (diffs.includes('state'))) &&
        !(sortBy === 'amount' && diffs.includes('amount')) &&
        !(sortBy === 'category' && diffs.includes('coa')) &&
        !(sortBy === 'reviewed' && diffs.includes('isReviewed')) &&
        !(sortBy === 'payee' && diffs.includes('payee')));
    return ret;
};
exports.optimalCacheCompareFn = optimalCacheCompareFn;
/*
  Recent Transactions
*/
/*
  General Process Grouped Txns
*/
const optimalCacheProcessFnTxnGrouped = (cachedValues, newTxn) => {
    let txIndex = -1;
    let sectionKey = null;
    cachedValues.forEach((sec, key) => {
        const foundTxn = sec.find((txn) => txn.id === newTxn.id);
        if (foundTxn) {
            sectionKey = key;
            txIndex = foundTxn.id;
        }
    });
    if (txIndex !== -1 && sectionKey) {
        log.debug('FOUND TXN AT ', sectionKey, txIndex, cachedValues.get(sectionKey));
        // check for deleted
        if (newTxn.isDeleted)
            return cachedValues.set(sectionKey, cachedValues.get(sectionKey).delete(txIndex));
        return cachedValues.setIn([sectionKey, txIndex], newTxn);
    }
    return cachedValues;
};
exports.optimalCacheProcessFnTxnGrouped = optimalCacheProcessFnTxnGrouped;
// this is for when the value is wrapped in a JS object (so the object pointer does not change)
const optimalCacheProcessFnRecentAcctTxns = (cachedObject, newTxn) => {
    assert(cachedObject === null || cachedObject === void 0 ? void 0 : cachedObject.immutableValue, 'optimalCacheProcessFnRecent was called without an immutable value');
    // eslint-disable-next-line no-param-reassign
    cachedObject.immutableValue = (0, exports.optimalCacheProcessFnTxnGrouped)(cachedObject.immutableValue, newTxn);
    return cachedObject;
};
exports.optimalCacheProcessFnRecentAcctTxns = optimalCacheProcessFnRecentAcctTxns;
/*
  General Compare PostedOn
*/
const optimalCacheCompareFnPostedOn = (oldTxn, newTxn) => {
    // determine which fields changed
    const diffs = (0, utils_1.getTxnDifferences)(oldTxn.toJS(), newTxn.toJS());
    log.debug('TXN DIFFS ARE (PostedOn)', diffs, !diffs.includes('postedOn'));
    return !diffs.includes('postedOn'); // always resort on date change
};
exports.optimalCacheCompareFnPostedOn = optimalCacheCompareFnPostedOn;
/*
  General Compare PostedOn and Amount
*/
const optimalCacheCompareFnPostedOnAndAmount = (oldTxn, newTxn) => {
    // determine which fields changed
    const diffs = (0, utils_1.getTxnDifferences)(oldTxn.toJS(), newTxn.toJS());
    log.debug('TXN DIFFS ARE (PostedOnAndAmount)', diffs, !diffs.includes('postedOn'));
    return !diffs.includes('postedOn') && !diffs.includes('amount'); // always resort on date or amount change
};
exports.optimalCacheCompareFnPostedOnAndAmount = optimalCacheCompareFnPostedOnAndAmount;
const optimalCacheCompareFnBubble = (oldTxn, newTxn) => {
    // determine which fields changed
    const diffs = (0, utils_1.getTxnDifferences)(oldTxn.toJS(), newTxn.toJS());
    log.debug('TXN DIFFS ARE (PostedOnAndAmount)', diffs, !diffs.includes('postedOn'));
    return !diffs.includes('postedOn') && !diffs.includes('amount') && !diffs.includes('coa') && !diffs.includes('payee') && !diffs.includes('isExcludedFromReports') && !diffs.includes('isExcludedFromF2S'); // always resort on date or amount change
};
exports.optimalCacheCompareFnBubble = optimalCacheCompareFnBubble;
/*
  General Process Txn List
*/
const optimalCacheProcessFnTxnList = (cachedValues, newTxn) => {
    const txIndex = cachedValues.findIndex((txn) => txn.id === newTxn.id);
    if (txIndex !== -1) {
        // check for deleted
        if (newTxn.isDeleted)
            return cachedValues.delete(txIndex);
        return cachedValues.set(txIndex, newTxn);
    }
    return cachedValues; // if new txn was deleted, and not found, that is ok
};
exports.optimalCacheProcessFnTxnList = optimalCacheProcessFnTxnList;
